import { render, staticRenderFns } from "./editIntegralConfig.vue?vue&type=template&id=04f9f8b5"
import script from "./editIntegralConfig.vue?vue&type=script&lang=js"
export * from "./editIntegralConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports